// Shared layout constants
export const COMPACT_GRID_WIDTH = '98px';
export const EXPANDED_GRID_WIDTH = '245px';
export const HEADER_HEIGHT = '90px';

